export function renderToimeksiantajaBlock({ data, content }) {

  const fields = {};

  const raw = data?.value?.trim();

  if (raw) {
    raw.split("\n").forEach(line => {
      const idx = line.indexOf(":");
      if (idx === -1) return;

      const key = line.slice(0, idx).trim();
      const value = line.slice(idx + 1).trim();

      fields[key] = value;
    });
  }

  const order = [
    "company",
    "contact",
    "street",
    "postalCity"
  ];

  const rows = order
    .map(key => fields[key])
    .filter(Boolean);

  const textValue =
    rows.length > 0
      ? rows.join("\n")
      : "Toimeksiantajan tietoja ei ole saatavilla.";

  content.push({
    text: textValue,
    style: "paragraph",
  });
}